<template>
  <CContainer :fluid="true">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">
              Currículos
            </h4>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol lg="12">
                <Search
                  value=""
                  @search="updateSearch"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol
                md="4"
                lg="4"
                xl="2"
              >
                <Datepicker
                  placeholder="De"
                  @selected="date => query.date_from = date"
                />
              </CCol>
              <CCol
                md="4"
                lg="4"
                xl="2"
              >
                <Datepicker
                  placeholder="Até"
                  @selected="date => query.date_to = date"
                />
              </CCol>
              <CCol
                md="4"
                lg="4"
                xl="2"
              >
                <div class="form-group select-arrow">
                  <select
                    v-model="query.level"
                    class="form-control"
                  >
                    <option
                      v-for="(option, index) in levelOptions"
                      :key="option[index]"
                      :value="option.value"
                      :disabled="option.disabled"
                      :selected="option.selected"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </CCol>
              <CCol
                md="4"
                lg="4"
                xl="2"
              >
                <div class="form-group select-arrow">
                  <select
                    v-model="query.status"
                    class="form-control"
                  >
                    <option
                      v-for="(option, index) in statusOptions"
                      :key="option[index]"
                      :value="option.value"
                      :disabled="option.disabled"
                      :selected="option.selected"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </CCol>
              <CCol
                md="4"
                lg="4"
                xl="2"
              >
                <div class="form-group select-arrow">
                  <select
                    v-model="query.featured"
                    class="form-control"
                  >
                    <option
                      v-for="(option, index) in featuredOptions"
                      :key="option[index]"
                      :value="option.value"
                      :disabled="option.disabled"
                      :selected="option.selected"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </CCol>
              <CCol
                md="4"
                lg="4"
                xl="2"
              >
                <div class="form-group select-arrow">
                  <select
                    v-model="query.classification"
                    class="form-control"
                  >
                    <option
                      v-for="(option, index) in classificationOptions"
                      :key="option[index]"
                      :value="option.value"
                      :disabled="option.disabled"
                      :selected="option.selected"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="12">
                <DataTable
                  :sorter="query.sorter"
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-export="false"
                  base-route="/jobaplications/edit/"
                  @sorterValue="event => query.sorter = event"
                  @row-clicked="handleRowClick"
                  @update:checked="updateStatus"
                >
                  <template #actions="{id}">
                    <DatatableEdit :url="`/jobaplications/edit/${id}`" />
                    <DatatableRemove
                      @row-clicked="handleRowClick"
                      @deleted="deleteJobAplication"
                    />
                  </template>
                </DataTable>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol lg="12">
                <Pagination
                  :page="query.page"
                  :per-page="query.perpage"
                  :pages="pagination.pages"
                  :total="pagination.total"
                  :items="pagination.items"
                  @update:active-page="page => query.page = page"
                  @update:perpage="perpage => query.perpage = perpage"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import DataTable from '@/components/ui/Datatable'
import DatatableEdit from '@/components/ui/DatatableActions/Edit'
import DatatableRemove from '@/components/ui/DatatableActions/Remove'
import Pagination from '@/components/ui/Pagination'
import Search from '@/components/ui/Search'
import Datepicker from '@/components/ui/Datepicker'

import JobAplicationService from '@/services/job-aplication.service'
import JobService from '@/services/job.service'
import moment from 'moment'

export default {
  metaInfo: {
    title: 'Projetos',
    titleTemplate: ' %s - Manager - OW Interactive'
  },
  components: {
    DataTable,
    DatatableEdit,
    DatatableRemove,
    Pagination,
    Search,
    Datepicker
  },

  data () {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'status',
            label: 'Status',
            _style: 'width: 10%'
          },

          {
            key: 'name',
            featured: true,
            label: 'Nome'
          },
          {
            key: 'title',
            label: 'Vaga'
          },
          {
            key: 'classification',
            label: 'Classificação'
          },
          {
            key: 'created_at',
            label: 'Enviado em'
          },
          {
            key: 'actions',
            label: 'Ações',
            sorter: false,
            _style: 'width: 10%'
          }
        ]
      },
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem') ? parseFloat(localStorage.getItem('perPageItem')) : 10,
        pagination: true,
        status: '',
        featured: '',
        job_id: '',
        classification: '',
        level: '',
        date_from: '',
        date_to: '',
        sorter: {
          asc: false,
          column: ''
        }
      },
      pagination: {
        total: 0,
        pages: 0,
        items: 0
      },
      statusOptions: [
        {
          value: '',
          label: 'Status'
        },
        {
          label: 'Ativo',
          value: true
        },
        {
          label: 'Inativo',
          value: false
        }
      ],
      featuredOptions: [
        {
          value: '',
          label: 'Destaque'
        },
        {
          label: 'Destacado',
          value: true
        },
        {
          label: 'Não destacado',
          value: false
        }
      ],
      classificationOptions: [
        {
          value: '',
          label: 'Classificação'
        },
        {
          value: '1',
          label: 'Pendente'
        },
        {
          value: '2',
          label: 'Em analise'
        },
        {
          value: '3',
          label: 'Recusado'
        },
        {
          value: '4',
          label: 'Aceito'
        }
      ],
      levelOptions: [
        {
          value: '',
          label: 'Nível'
        }
      ],
      rowCliked: {}
    }
  },

  watch: {
    query: {
      handler:
        'updateDataTable',
      deep: true
    }
  },

  async created () {
    await this.getFormOptions()
    await this.updateDataTable()
  },

  methods: {
    async getFormOptions () {
      const response = await JobService.getJobFormOption()

      const jobLevels = response.jobLevels.map(level => {
        return {
          value: level.id,
          label: level.title
        }
      })

      this.levelOptions = [...this.levelOptions, ...jobLevels]
    },

    async updateDataTable () {
      if (this.$route.query.job_id) {
        this.query.job_id = this.$route.query.job_id
      }
      const response = await JobAplicationService.getAll(this.query)
      const { total, lastPage: pages } = response

      if (response.data) {
        this.pagination = {
          total,
          pages,
          items: response.data.length
        }

        const newItems = response.data.map(item => {
          return {
            id: item.id,
            featured: item.featured,
            title: `${item.job?.title} <br> ${item.job?.job_level?.title}`,
            classification: item.classification && item.classification.title,
            name: `${item.name} <br> ${item.email}`,
            email: item.email,
            created_at: moment(item.created_at).format('DD/MM/YYYY HH:mm'),
            status: item.status === 1
          }
        })

        this.datatable.items = newItems
      }
    },

    async updateSearch (searchText) {
      this.query.search = searchText
      this.query.page = 1
      await this.updateDataTable()
    },

    handleRowClick (event) {
      this.rowCliked = event
    },

    async updateStatus (event) {
      const response = await JobAplicationService.updateStatus(this.rowCliked, event)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Status alterado com sucesso'
        })
        await this.updateDataTable()
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Ocorreu um erro ao atualizar o status, por favor tente novamente!'
        })
      }
    },
    // Excluir
    async deleteJobAplication () {
      const response = await JobAplicationService.deleteJobAplication(this.rowCliked)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Currículo excluído com sucesso!'
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Não é possivel excluir o currículo'
        })
      }

      await this.updateDataTable()
    }
  }
}
</script>
